import { buildRiderNote } from './riderNote.js';

/**
 * The exact body the passenger app sends to the `createRide` callable.
 *
 * Kept as a pure function (the Firebase service module can't be imported in a
 * plain node test) so a field Book.js adds — like the pickup tip — can never
 * be silently dropped on the way to the server again.
 */
export const buildCreateRidePayload = (rideData) => {
  const payload = {
    pickup: rideData.pickup,
    destination: rideData.destination,
    customerName: rideData.customerName,
  };
  if (rideData.distanceKm != null && Number.isFinite(Number(rideData.distanceKm))) {
    payload.distanceKm = Number(rideData.distanceKm);
  }
  // Optional pickup tip the rider chose. Whole rupees only; the server
  // re-validates it against its own nearest-auto distance.
  const tip = Number(rideData.tip);
  if (rideData.tip != null && Number.isInteger(tip) && tip > 0) {
    payload.tip = tip;
  }
  // The id of the waiting-charge terms the rider was shown (from the quote). The
  // server compares it with its current terms; it never takes rates from here.
  // Only sent when terms were actually shown, so an older server/feature-off
  // booking is unchanged.
  const termsId = typeof rideData.waitingTermsId === 'string' ? rideData.waitingTermsId.trim() : '';
  if (/^\d{1,3}-\d{1,3}-\d{1,3}$/.test(termsId)) {
    payload.waitingTermsId = termsId;
  }
  // Optional note for the Anna (utils/riderNote.js). Only sent when there is one,
  // so a booking without a note is byte-for-byte what it was before.
  const note = rideData.riderNote ? buildRiderNote(rideData.riderNote.chips, rideData.riderNote.text) : null;
  if (note) payload.riderNote = note;
  if (rideData.isBookingForOther) {
    payload.isBookingForOther = true;
    payload.riderName = String(rideData.riderName || '').trim();
    payload.riderPhone = String(rideData.riderPhone || '').replace(/\D/g, '').slice(-10);
  }
  return payload;
};
